export default __webpack_public_path__ + "locales/it/FillPDFDialog.json?hash=56b91e47b4702ba762e126329a790584";